import { find } from 'lodash'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    modalVisible: false,
    lessonId: '',

    searchResult: [],
    searchQuery: '',
    searchOverView: false,
    searchFocus: false,

    tabUrl: '',
    selectedLang: 'en',
    userFavorites: [],

    muteTeaser: true,

    navMenuId: '',

    cursusBoxes: {},
    cursusBoxPreviews: [],
    cursusLesson: '',
    cursusBox: '',
    cursusMethod: 'Finger',
    cursusTrack: 0,
    cursusFullSelected: false,
    cursusSelectedStep: 0,
    
    lessonArtist:"",

    knowledgeApi: [],
    knowledgeVideo: {},

    discoveryModeState: "undefined",
    discoveryModeSemaphore: true
  },
  mutations: {
    setLessonId(state, id) {
      state.lessonId = id
      localStorage.lessonId = id;
    },
    setModalVisible(state, visible) {
      state.modalVisible = visible
    },
    setSelectedLang(state, lang) {
      state.selectedLang = lang;
      localStorage.lang = lang;
    },
    setUserFavorites(state, favorites) {
      state.userFavorites = favorites;
        localStorage.userFavorites = JSON.stringify(favorites);
    },
    
    setSearchResult (state, res) {
      state.searchResult = res
      localStorage.searchResult = JSON.stringify(res)
    },
    setSearchQuery(state, str) {
      state.searchQuery = str
      localStorage.searchQuery = str
    },
    setSearchOverView(state, visible) {
      if (visible === "true") {
        visible = true
      }
      else if (visible === "false") {
        visible = false
      }
      state.searchOverView = visible
      localStorage.searchOverView = visible
    },
    setSearchFocus(state, focus) {
      if (focus === "true") {
        focus = true
      }
      else if (focus === "false") {
        focus = false
      }
      state.searchFocus = focus
    },
    setTabUrl(state, url) {
      state.tabUrl = url
      localStorage.tabUrl = url
    },
    setMuteTeaser(state, mute) {
      state.muteTeaser = mute
      localStorage.muteTeaser = mute
    },
    setNavMenuId(state, id) {
      state.navMenuId = id
      localStorage.navMenuId = id
    },
    setCursusBoxes(state, boxes) {
      state.cursusBoxes = boxes
      localStorage.cursusBoxes = JSON.stringify(boxes)
    },
    setCursusBoxPreviews(state, previews) {
      state.cursusBoxPreviews = previews
      localStorage.cursusBoxPreviews = JSON.stringify(previews)
    },
    setCursusLesson(state, lesson) {
      state.cursusLesson = lesson
    },
    setCursusBox(state, box) {
      state.cursusBox = box
    },
    setCursusMethod(state, method) {
      state.cursusMethod = method
      localStorage.cursusMethod = method
    },
    setCursusTrack(state, track) {
      state.cursusTrack = track
    },
    setCursusFullSelected(state, selection) {
      state.cursusFullSelected = selection;
    },
    setCursusSelectedStep(state, step) {
      state.cursusSelectedStep = step;
    },

    setKnowledgeApi(state, api) {
      state.knowledgeApi = api;
      localStorage.knowledgeApi = JSON.stringify(api);
    },
    setKnowledgeVideo(state, video) {
      state.knowledgeVideo = video
    },

    setDiscoveryModeState(state, modeState) {
      state.discoveryModeState = modeState
    },
    setDiscoveryModeSemaphore(state, semaphoreState) {
      state.discoveryModeSemaphore = semaphoreState
    },
  },
  actions: {
    ReplicateSearch ({ commit }) {
      if (localStorage.searchResult != undefined) {
        commit("setSearchResult", JSON.parse(localStorage.searchResult))
      }
      commit("setSearchQuery", localStorage.searchQuery)
      commit("setSearchOverView", localStorage.searchOverView)
    },
    ReplicateLocal({commit}) {
      commit("setTabUrl", localStorage.tabUrl)
      commit("setMuteTeaser", localStorage.muteTeaser)
      commit("setNavMenuId", localStorage.navMenuId)
      commit("setLessonId", localStorage.lessonId)
      commit("setSelectedLang", localStorage.lang)
      if (localStorage.userFavorites != undefined) {
        commit("setUserFavorites", JSON.parse(localStorage.userFavorites))
      }
      if (localStorage.cursusBoxes != undefined) {
        commit("setCursusBoxes", JSON.parse(localStorage.cursusBoxes))
      }
      if (localStorage.cursusBoxPreviews != undefined) {
        commit("setCursusBoxPreviews", JSON.parse(localStorage.cursusBoxPreviews))
      }
      commit("setCursusMethod", localStorage.cursusMethod)
      if (localStorage.knowledgeApi != undefined) {
        commit("setKnowledgeApi", JSON.parse(localStorage.knowledgeApi))
      }
    },

  },
  getters: {
    lessonId: state => {
      return state.lessonId
    },
    modalVisible: state => {
      return state.modalVisible
    },

    searchResult: state => {
      return state.searchResult
    },
    searchQuery: state => {
      return state.searchQuery
    },
    searchOverView: state => {
      return state.searchOverView
    },
    searchFocus: state => {
      return state.searchFocus
    },
    tabUrl: state => {
      return state.tabUrl
    },
    selectedLang: state => {
      return state.selectedLang
    },
    muteTeaser: state => {
      return state.muteTeaser
    },
    userFavorites: state => {
      return state.userFavorites
    },
    navMenuId: state => {
      return state.navMenuId
    },

    cursusBoxes: state => {
      return state.cursusBoxes
    },
    cursusBoxPreviews: state => {
      return state.cursusBoxPreviews
    },
    cursusLesson: state => {
      return state.cursusLesson
    },
    cursusBox: state => {
      return state.cursusBox
    },
    cursusMethod: state => {
      return state.cursusMethod
    },
    cursusTrack: state => {
      return state.cursusTrack
    },
    cursusFullSelected: state => {
      return state.cursusFullSelected
    },
    cursusSelectedStep: state => {
      return state.cursusSelectedStep
    },

    knowledgeApi: state => {
      return state.knowledgeApi
    },
    knowledgeVideo: state => {
      return state.knowledgeVideo
    },

    discoveryModeState: state => {
      return state.discoveryModeState
    },
    discoveryModeSemaphore: state => {
      return state.discoveryModeSemaphore
    }
  },
  modules: {
  },
})
